import React, { useState } from "react";
import {
  Button,
  Grid,
  Paper,
  styled,
  TextField,
  Typography,
  Box,
  Chip
} from "@mui/material";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Field, Form } from "react-final-form";
import CalendarPicker from "../../pickers/CalenderPicker";
import { getClaims } from "../../action";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem 1rem",
}));

function ClaimFilter() {
  const { t } = useTranslation();
  const [dropValue, setDropValue] = useState(0);
  const [showCalendar, setShowCalendar] = useState(false);
  const [searchFilters, setSearchFilters] = useState({
      prestationNumber: "",
      status: "",
      date: "",
      dateFrom: "",
      dateTo: "",
  });
  const [label, setLabel] = useState("Enter CAMU No.");
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const value = event.target.value;
    setDropValue(value);
    getLabel(value);
    setShowCalendar(value === "3");
  };

  const handleSearch = () => {
    let params = buildQueryParams({
      filters: {},
      orderBy: ["-dateClaimed"],
      first: 10,
    });
    dispatch(getClaims(params));
  };

  const handleClear = () => {
    setSearchFilters({
      prestationNumber: "",
      status: "",
      date: "",
      dateFrom: "",
      dateTo: "",
    });
    let params = buildQueryParamsClear({
      filters: {},
      orderBy: ["-dateClaimed"],
      first: 10,
    });
    dispatch(getClaims(params));
  };

  const buildQueryParamsClear = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.first) {
      params.push(`first: ${state.first}`);
    }
    return params;
  };

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if(searchFilters.prestationNumber) {
      params.push(`code_Icontains: "${searchFilters.prestationNumber}"`);
    }
    if(searchFilters.status) {
      params.push(`status: ${searchFilters.status}`);
    }
    if(searchFilters.date) {
      params.push(`dateClaimed: "${searchFilters.date}"`);
    }
    if(searchFilters.dateFrom) {
      params.push(`dateClaimed_Gte: "${searchFilters.dateFrom}"`);
    }
    if(searchFilters.dateTo) {
      params.push(`dateClaimed_Lt: "${searchFilters.dateTo}"`);
    }
    if (!!state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (!!state.first) {
      params.push(`first: ${state.first}`);
    }
    return params;
  };

  const getLabel = (value) => {
    switch (value) {
      case 1:
        setLabel("EnterClaimNo.");
        break;
      case 2:
        setLabel("ClaimStatus");
        break;
      case 3:
        setLabel("EnterClaimedDate");
        break;
      case 4:
        setLabel("EnterClaimedDatePeriod");
        break;
      default:
        setLabel("EnterCAMUNo.");
        break;
    }
  };

  const searchType = [
    {
      value: 1,
      label: t("ClaimNo."),
    },
    {
      value: 2,
      label: t("ClaimStatus"),
    },
    {
      value: 3,
      label: t("ClaimedDate"),
    },
    {
      value: 4,
      label: t("ClaimedDatePeriod"),
    },
  ];

  const claimStatus = [
    {
      value: "1",
      label: t("Rejected"),
    },
    {
      value: "2",
      label: t("Created"),
    },
    {
      value: "4",
      label: t("Submitted"),
    },
    {
      value: "8",
      label: t("Processed"),
    },
    {
      value: "16",
      label: t("Approved"),
    },
    {
      value: "32",
      label: t("Rework"),
    },
    {
      value: "64",
      label: t("Paid"),
    },
  ];

  const SelectedFilters = () => {
    return (
      <Grid style={{
        display: "flex", 
        flexDirection: "row", 
        gap: "0.5rem", 
        marginLeft: "1.4rem", 
        paddingBottom: "1.4rem" 
      }}>
        {searchFilters.prestationNumber && <Chip label={searchFilters.prestationNumber} />}
        {searchFilters.status && <Chip label={claimStatus.find(status => status.value === searchFilters.status)?.label} />}
        {searchFilters.date && <Chip label={`${searchFilters.date}`} />}
        {searchFilters.dateFrom && <Chip label={`A partir du ${searchFilters.dateFrom}`} />}
        {searchFilters.dateTo && <Chip label={`Jusqu'au ${searchFilters.dateTo}`} />}
      </Grid>
    )
  } 

  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader>
            <Grid item alignItems="center">
              <Typography variant="h6">{t("Search Criteria")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <Form
            autoComplete="off"
            onSubmit={(values) => {
              console.log(values);
            }}
            render={({ handleSubmit, form }) => (
              <form onSubmit={handleSubmit}>
                <Grid
                  style={{
                    display: "flex",
                    paddingLeft: "1rem",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Grid item xs={3} className="common-input">
                    <Typography color="#000" fontSize="14">
                      {t("Search Criteria")}
                    </Typography>
                    <Field
                      name="typeOfSearch"
                      component={Dropdown}
                      options={searchType}
                      input={{ value: dropValue, onChange: handleChange }}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    {dropValue !== 0 && (
                      <Typography color="#000" fontSize="24">
                        {t(label)}
                      </Typography>
                    )}
                    {dropValue === 1 && (
                      <TextField
                        name="name"
                        value={searchFilters.prestationNumber}
                        onChange={(e) => {
                          setSearchFilters(prev => ({
                            ...prev,
                            prestationNumber: e.target.value,
                          }))
                        }}
                        size="small"
                        type="text"
                        autoComplete="off"
                      />
                    )}

                    {dropValue === 2 && !showCalendar && (
                      <Field
                        name="claimType"
                        component={Dropdown}
                        options={claimStatus}
                        input={{
                          value: searchFilters.status,
                          onChange: (e) => {
                            setSearchFilters(prev => ({
                              ...prev,
                              status: e.target.value,
                            }))
                          },
                        }}
                      />
                    )}

                    {dropValue === 3 && (
                      <Field
                        name="validTo"
                        // label={label}
                        component={CalendarPicker}
                        inputVal={searchFilters.date}
                        onChange={(value) => {
                          setSearchFilters(prev => ({
                            ...prev,
                            date: value,
                            dateFrom: null,
                            dateTo: null,
                          }))
                        }}
                      />
                    )}

                    {dropValue === 4 && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                      >
                        <Field
                          name="validFrom"
                          component={CalendarPicker}
                          inputVal={searchFilters.dateFrom}
                          onChange={(value) => {
                            setSearchFilters(prev => ({
                              ...prev,
                              dateFrom: value,
                              date: null,
                            }))
                          }}
                        />

                        <Box sx={{ mx: 2 }}></Box>

                        <Field
                          name="validTo"
                          component={CalendarPicker}
                          inputVal={searchFilters.dateTo}
                          onChange={(value) => {
                            setSearchFilters(prev => ({
                              ...prev,
                              dateTo: value,
                              date: null,
                            }))
                          }}
                        />
                      </Box>
                    )}
                  </Grid>
                  {dropValue !== 0 && (
                    <Grid
                      item
                      xs={8}
                      style={{ display: "flex", marginTop: "1.4rem" }}
                    >
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSearch}
                        >
                          {t("Search")}
                        </Button>
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleClear}
                          style={{ marginLeft: "1rem" }}
                        >
                          {t("Clear")}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </form>
            )}
          />
          <SelectedFilters />
        </StyledPaper>
      </Grid>
    </Grid>
  );
}

export default ClaimFilter;
